var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42851 2.32149C6.07938 2.97237 6.07938 4.02764 5.42851 4.67852C4.77764 5.32939 3.72236 5.32939 3.07148 4.67852C2.42061 4.02764 2.42061 2.97237 3.07148 2.32149C3.72236 1.67062 4.77763 1.67062 5.42851 2.32149",
    stroke: "#73737B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8065 1.61019C13.6201 2.42378 13.6201 3.74287 12.8065 4.55646C11.9929 5.37006 10.6738 5.37006 9.86023 4.55646C9.04663 3.74287 9.04663 2.42378 9.86023 1.61019C10.6738 0.796598 11.9929 0.796598 12.8065 1.61019",
    stroke: "#73737B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0833 11V10.1667C15.0833 8.78583 13.9642 7.66666 12.5833 7.66666H10.0833C8.7025 7.66666 7.58334 8.78583 7.58334 10.1667V11",
    stroke: "#73737B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08333 7.66666H3.41667C2.03583 7.66666 0.916668 8.78583 0.916668 10.1667V11",
    stroke: "#73737B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuests);
export default __webpack_public_path__ + "static/media/guests.3a99e321.svg";
export { ForwardRef as ReactComponent };